module.exports = __webpack_public_path__ + "static/media/relay-mobile-dashboard.3b03246c.png";